export const defaultScenarioCopy = [
  {
    label: "Disinflation",
    description:
      "This scenario is modeled as a strong negative shock to the US inflation curve.",
  },
  {
    label: "Reflation",
    description:
      "This scenario is modeled as a small positive shock to the US inflation curve.",
  },
  {
    label: "Inflation Overheating",
    description:
      "This scenario is modeled as a strong positive shock to the US inflation curve.",
  },
  {
    label: "Stagflation",
    description:
      "This scenario is modeled as an extremely positive shock to the US inflation curve.",
  },
];

export const expandedScenarioCopy = [
  {
    label: "Disinflation",
    description:
      "This scenario is modeled as a strong negative shock to the US inflation curve. (US 2 year inflation factor is shocked by -150 bps)",
  },
  {
    label: "Reflation",
    description:
      "This scenario is modeled as a small positive shock to the US inflation curve. (US 2 year inflation factor is shocked by +75 bps)",
  },
  {
    label: "Inflation Overheating",
    description:
      "This scenario is modeled as a strong positive shock to the US inflation curve. (US 2 year inflation factor is shocked by +150 bps)",
  },
  {
    label: "Stagflation",
    description:
      "This scenario is modeled as an extremely positive shock to the US inflation curve. (US 2 year inflation factor is shocked by +200 bps)",
  },
];
